export default {
  enotesAutoplay: false,
  //메인 - 배너
  swiperOptionsBanner: {
    slidesPerView: 1,
    initialSlide: 0,
    loop: true,
    // simulateTouch: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return (
          '<span class="swiper-pagination-current">' +
          current +
          '</span>' +
          '<span class="swiper-pagination-divider"> / </span>' +
          '<span class="swiper-pagination-total">' +
          total +
          '</span>' +
          '<span class="swiper-pagination-next"></span>'
        )
      }
    },
    speed: 1500,
    autoplay: {
      delay: 6500
    }
    // navigation: { clickable: true }
  },
  //메인 - 우리학교는
  swiperOptionsBook: {
    slidesPerView: 'auto',
    spaceBetween: 30,
    breakpoints: {
      320: {
        spaceBetween: 15
      },
      480: {
        spaceBetween: 20
      },
      768: {
        spaceBetween: 20
      },
      1024: {
        spaceBetween: 30
      }
    }
  },
  //메인 - e북 슬라이드
  swiperOptionsEBook1: {
    slidesPerView: 'auto',
    initialSlide: 0,
    spaceBetween: 25,
    centeredSlides: true,
    loop: true,
    controller: {
      control: null // 초기 값은 null로 설정
    },
    breakpoints: {
      320: {
        spaceBetween: 10
      },
      480: {
        spaceBetween: 10
      },
      768: {
        spaceBetween: 10
      }
    }
  },
  swiperOptionsEBook2: {
    slidesPerView: 'auto',
    initialSlide: 0,
    spaceBetween: 25,
    centeredSlides: true,
    loop: true,
    touchRatio: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    controller: {
      control: null // 초기 값은 null로 설정
    }
  },
  //메인 - 이벤트 배너

  swiperOptionsEventBanner: {
    slidesPerView: 1,
    initialSlide: 1,
    spaceBetween: 25,
    loop: true,
    simulateTouch: true,
    pagination: {
      el: '.event-swiper-pagination',
      clickable: true
    },
    speed: 1500,
    autoplay: {
      delay: 6500
    }
    // navigation: { clickable: true }
  },
  // 메인 - 베스트/신간 슬라이드
  swiperOptionsBestNew: {
    slidesPerView: 'auto',
    spaceBetween: 25
  },
  // 메인 - 카테고리, 장르별 슬라이드
  swiperOptionsCatagory: {
    slidesPerView: 'auto',
    initialSlide: 0,
    controller: {
      control: null // 초기 값은 null로 설정
    },
    breakpoints: {
      320: {
        spaceBetween: 15
      },
      480: {
        spaceBetween: 20
      },
      768: {
        spaceBetween: 25
      }
    }
  },
  // 이벤트 상세페이지
  fixedSlide1: {
    slidesPerView: 3.8,
    // initialSlide: 2.5,
    loop: true,
    // centeredSlides: true,
    simulateTouch: false
  },
  fixedSlide2: {
    slidesPerView: 3.5,
    // initialSlide: 2.5,
    loop: true,
    // centeredSlides: true,
    simulateTouch: false
  },
  //전자책 구매 가이드
  swiperOptionsHelp: {
    direction: 'horizontal',
    loop: false,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    // Navigation arrows
    navigation: {
      nextEl: '#guideNext',
      prevEl: '#guidePrev'
    },
    virtual: 'true'
  },
  // 뷰어 이용 가이드
  swiperOptionsVeiwerGuide: {
    direction: 'horizontal',
    loop: false,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    // Navigation arrows
    navigation: {
      nextEl: '#vGuideNext',
      prevEl: '#vGuidePrev'
    },
    virtual: 'true'
  },
  // 관련 교재
  swiperOptionsRelated: {
    slidesPerView: 6,
    loop: false,
    navigation: {
      nextEl: '#relatedNext',
      prevEl: '#relatedPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      500: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 6,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 52,
        height: 170
      },
      1440: {
        slidesPerView: 6,
        spaceBetween: 44
      }
    }
  },
  // 추천 교재
  swiperOptionsRecommended: {
    slidesPerView: 6,
    loop: false,
    navigation: {
      nextEl: '#recommendedNext',
      prevEl: '#recommendedPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      500: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 8,
        spaceBetween: 20,
        height: 113
      },
      900: {
        slidesPerView: 10,
        spaceBetween: 15,
        height: 113
      },
      1024: {
        slidesPerView: 10,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 10,
        spaceBetween: 44
      }
    }
  },
  // 신규 교재
  swiperOptionsNew: {
    slidesPerView: 3,
    loop: false,
    navigation: {
      nextEl: '#newNext',
      prevEl: '#newPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      550: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 35
      },
      929: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 50
      }
    }
  },
  // 학부 카테고리
  swiperOptionsCategory: {
    spaceBetween: 15,
    loop: false,
    navigation: {
      nextEl: '#categoryNext',
      prevEl: '#categoryPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 4,
        spaceBetween: 25,
        width: 280
      },
      500: {
        slidesPerView: 5,
        spaceBetween: 25,
        width: 420
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 25,
        width: 550
      },
      768: {
        slidesPerView: 8,
        spaceBetween: 30,
        width: 710
      },
      900: {
        slidesPerView: 9,
        width: 850
      },
      1024: {
        slidesPerView: 9,
        width: 1000
      },
      1440: {
        slidesPerView: 10,
        width: 1000
      }
    }
  },
  // E-노트
  swiperOptionsEnotes: {
    loop: true,
    autoplay: true,
    paginationClickable: true,
    pagination: {
      el: '.swipe_ctrl',
      clickable: true
    },
    navigation: {
      nextEl: '#enotesNext',
      prevEl: '#enotesPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      400: {
        slidesPerView: 3,
        spaceBetween: 20,
        width: 350
      },
      500: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      929: {
        slidesPerView: 2.7
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 2,
        spaceBetween: 50
      }
    }
  },
  // 인기 교재
  swiperOptionsPopular: {
    loop: false,
    navigation: {
      nextEl: '#popularNext',
      prevEl: '#popularPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        width: 300,
        spaceBetween: 20
      },
      500: {
        slidesPerView: 5,
        spaceBetween: 20,
        width: 445
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 20,
        width: 596
      },
      768: {
        slidesPerView: 8,
        spaceBetween: 15,
        width: 725
      },
      900: {
        slidesPerView: 9,
        spaceBetween: 15,
        width: 760
      },
      1024: {
        slidesPerView: 10,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 10,
        spaceBetween: 44
      }
    }
  },
  // 전자 도서관
  swiperOptionsEbook: {
    loop: false,
    navigation: {
      nextEl: '#ebooksNext',
      prevEl: '#ebooksPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        width: 300,
        spaceBetween: 20
      },
      500: {
        slidesPerView: 5,
        spaceBetween: 20,
        width: 445
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 20,
        width: 595
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 30,
        width: 677
      },
      900: {
        slidesPerView: 6,
        spaceBetween: 30,
        width: 845
      },
      1024: {
        slidesPerView: 7,
        spaceBetween: 20,
        width: 980
      },
      1440: {
        slidesPerView: 8,
        spaceBetween: 20,
        width: 1180
      }
    }
  },
  // SELFBOOKS
  swiperOptionsPopularSelfbook: {
    slidesPerView: 6,
    loop: false,
    navigation: {
      nextEl: '#selfbookPopularNext',
      prevEl: '#selfbookPopularPrev'
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 20,
        width: 250
      },
      500: {
        slidesPerView: 4,
        spaceBetween: 25,
        width: 440
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 20,
        width: 600
      },
      768: {
        slidesPerView: 6,
        spaceBetween: 27,
        width: 798
      },
      900: {
        slidesPerView: 6,
        spaceBetween: 36,
        width: 920
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 47,
        width: 970
      },
      1440: {
        slidesPerView: 6,
        spaceBetween: 44,
        width: 1180
      }
    }
  }
}
